module.exports = __webpack_public_path__ + "static/media/CV_Dallas_Hermanson_2023.c1eee844.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/assets/CV_Dallas_Hermanson_2023.pdf
// module id = 86
// module chunks = 0